import productService from "./productService";

const salesService = [
    ...productService
]

export { salesService as default, productService }